// Fetch Roles
export const FETCH_ROLES_REQUEST = 'FETCH_ROLE_REQUEST';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLE_SUCCESS';
export const FETCH_ROLES_ERROR = 'FETCH_ROLE_ERROR';

// Fetching Loader
export const SHOW_ROLE_LOADER = 'SHOW_ROLE_LOADER';
export const HIDE_ROLE_LOADER = 'HIDE_ROLE_LOADER';

// Create Role
export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_ERROR = 'CREATE_ROLE_ERROR';
export const CREATE_ROLE_RESET = 'CREATE_ROLE_RESET';

// Update Role
export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';
export const UPDATE_ROLE_RESET = 'UPDATE_ROLE_RESET';

// Get Maker Details
export const FETCH_ROLE_MAKERS_REQUEST = 'FETCH_ROLE_MAKERS_REQUEST';
export const FETCH_ROLE_MAKERS_SUCCESS = 'FETCH_ROLE_MAKERS_SUCCESS';
export const FETCH_ROLE_MAKERS_ERROR = 'FETCH_ROLE_MAKERS_ERROR';

// Fetch All Resource Permission
export const FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST =
    'FETCH_ALL_RESOURCE_PERMISSIONS_REQUEST';
export const FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS =
    'FETCH_ALL_RESOURCE_PERMISSIONS_SUCCESS';
export const FETCH_ALL_RESOURCE_PERMISSIONS_ERROR =
    'FETCH_ALL_RESOURCE_PERMISSIONS_ERROR';
